import { BrokerUser } from '@insurance/api/requests'
import { AgentStatusTag } from '@insurance/components'
import { ConditionalText, TableActions, Text } from '@shared/components'
import { getFullName } from '@shared/utils'
import { ColumnProps } from 'antd/es/table'
import { MenuProps } from 'antd/lib'
import { TFunction } from 'i18next'

import { AgentTeams } from '../AgentTeams'

export const getTableColumns = (
  actions: (content: BrokerUser) => MenuProps['items'],
  t: TFunction
): ColumnProps<BrokerUser>[] => [
  {
    title: t('name'),
    key: 'first_name',
    sorter: true,
    render: (_, user) => getFullName(user)
  },
  {
    title: t('email'),
    key: 'email',
    dataIndex: 'email',
    sorter: true,
    render: (email) => (
      <ConditionalText condition={!!email}>{email}</ConditionalText>
    )
  },
  {
    title: t('identification_number'),
    key: 'identification_number',
    dataIndex: 'identification_number',
    render: (personal_code) => (
      <ConditionalText condition={!!personal_code}>
        {personal_code}
      </ConditionalText>
    )
  },
  {
    title: t('teams'),
    key: 'teams',
    dataIndex: 'teams',
    render: (team) => <AgentTeams teams={team} />
  },
  {
    title: t('phone'),
    key: 'phone',
    dataIndex: 'phone',
    render: (phone) => (
      <ConditionalText condition={!!phone}>{phone}</ConditionalText>
    )
  },
  {
    title: t('administrator'),
    key: 'is_broker_admin',
    dataIndex: 'is_broker_admin',
    render: (value) =>
      value ? (
        <Text type="success">{t('yes')}</Text>
      ) : (
        <Text type="danger">{t('no')}</Text>
      )
  },
  {
    title: t('status'),
    key: 'status',
    dataIndex: 'status',
    render: (status) => <AgentStatusTag status={status} />
  },
  {
    key: 'actions',
    align: 'center',
    width: 80,
    render: (_, row) => <TableActions options={actions(row)} />
  }
]
